import React from 'react';
import { Stack, Tab } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Theme } from '@mui/material/styles';

interface TabsProps {
  tabs: Array<any>;
  value: string;
  onChange: (event: React.SyntheticEvent, newValue: string) => void;
  tabPanelStyles?: React.CSSProperties;
}

const DynamicTabs = ({ tabs, value, onChange, tabPanelStyles = {} }: TabsProps) => {
  const downMD = useMediaQuery((theme: Theme) => theme.breakpoints.down(1024));
  const downSM = useMediaQuery((theme: Theme) => theme.breakpoints.down(600));

  return (
    <TabContext value={value}>
      <Stack
        direction="row"
        display="flex"
        alignItems="center"
        justifyContent="flex-start"
        spacing={2}
        sx={{
          my: 1,
          mx: 2,
          width: '100%',
          overflowX: 'auto',
          whiteSpace: 'nowrap',
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': {
            display: 'none'
          }
        }}
      >
        <TabList
          onChange={onChange}
          aria-label="dynamic tabs"
          sx={{
            display: 'flex',
            flexWrap: 'nowrap',
            overflowX: 'auto',
            minWidth: 'max-content',
            WebkitOverflowScrolling: 'touch',
            scrollbarWidth: 'none',
            '&::-webkit-scrollbar': {
              display: 'none'
            }
          }}
          TabIndicatorProps={{
            style: { display: 'none' }
          }}
        >
          {tabs.map((tab) => (
            <Tab
              key={tab.value}
              value={tab.value}
              label={tab.label}
              style={{
                fontFamily: 'poppins',
                background: value === tab.value ? '#E1ECFF' : '#E0E0E0',
                width: downSM ? 'auto' : downMD ? 'auto' : '180px',
                height: downSM ? '34px' : downMD ? '38px' : '45px',
                border: value === tab.value ? '1px solid #063B9A' : 'none',
                color: value === tab.value ? '#063B9A' : '#666666',
                borderRadius: '15px',
                fontWeight: '600',
                fontSize: downSM ? '14px' : downMD ? '16px' : '18px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                whiteSpace: 'nowrap',
                marginRight: downSM ? '8px' : '20px',
                ...tab.customStyle
              }}
            />
          ))}
        </TabList>
      </Stack>

      {tabs.map((tab) => (
        <TabPanel key={tab.value} value={tab.value} sx={{ width: '100% !important', padding: '0px !important', ...tabPanelStyles }}>
          {tab.content}
        </TabPanel>
      ))}
    </TabContext>
  );
};

export default DynamicTabs;
